export default "# Magic Item\n\n::demo{name=magic-item}\n"